var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-upload',_vm._b({ref:"upload",staticStyle:{"margin-left":"80px"},attrs:{"data":_vm.uploaderData}},'base-upload',_vm.$attrs,false),[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v(_vm._s(_vm.buttonName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }